export class SubtypesDiligences {
    get id() {
        return this.subtypesDiligencesState.id;
    }
    get diligenceCode() {
        return this.subtypesDiligencesState.diligenceCode;
    }
    get subTypeDiligence() {
        return this.subtypesDiligencesState.subTypeDiligence;
    }
    get antecedent() {
        return this.antecedent;
    }
    set subTypeDiligence(subTypeDiligence) {
        this.subtypesDiligencesState.subTypeDiligence = subTypeDiligence;
    }
    constructor(subtypesDiligencesState) {
        this.subtypesDiligencesState = subtypesDiligencesState;
    }
    getState() {
        return this.subtypesDiligencesState;
    }
}
